<template>
	<b-modal
        hide-footer

		size="xl"
		v-model="model"
		:title="$t('rates.mapTitle')"
	>
		<b-row>
			<b-col cols="12" sm="3">
				<p class="h4">
					{{
						$t("rates.listTitle", {
							zone: zoneSelected.zonedAreaName
						})
					}}
				</p>
				<b-list-group>
					<b-list-group-item
						:active="item.active"
						v-for="(item, i) of zones"
						:key="i"
						@click="selectZone(item)"
						>{{ item.name }}</b-list-group-item
					>
				</b-list-group>
			</b-col>
			<b-col cols="12" sm="9">
				<p class="h4 text-center">
					{{ $t("rates.zoneTitle") }} {{ editingZone.name }}
				</p>
				<div id="zones-map" ref="map"></div>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
export default {
	props: {
		value: Boolean,
		zoneSelected: Object
	},
	data() {
		return {
			map: null,
			zones: [],
			infoWindow: [],
			loading: false,
			polygonEditableOpts: {
				strokeColor: "#3fb618",
				fillColor: "#3fb618",
				editable: false,
				draggable: false
			},
			polygonNotEditableOpts: {
				strokeColor: "#dc3545",
				fillColor: "#dc3545",
				editable: false,
				draggable: false
			}
		};
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit("input", v);
			}
		},
		editingZone() {
			return (
				this.zones.find(({ active }) => active === true) || { name: "" }
			);
		}
	},
	mounted() {
		setTimeout(() => {
			this.initMap();
			this.fetchModel();
		}, 1000);
	},
	methods: {
		initMap() {
			this.map = new window.google.maps.Map(this.$refs["map"], {
				center: { lat: 21.1214886, lng: -86.9192742 },
				zoom: 9,
				streetViewControl: false
			});
		},
		selectZone({ id }) {
			this.zones = this.zones.map(zone => {
				if (zone.id === id) {
					this.closeInfoWindows();
					this.infoWindow.map(infoWindow => {
						if (infoWindow.data.id === id) {
							infoWindow.open({
								anchor: infoWindow.marker,
								map: this.map,
								shouldFocus: false
							});
						}
					});
					zone.polygon.setOptions(this.polygonEditableOpts);
					return { ...zone, active: true };
				} else {
					zone.polygon.setOptions(this.polygonNotEditableOpts);
					return { ...zone, active: false };
				}
			});
		},
		fetchModel() {
			this.loading = true;
			this.$root.api
				.get(`rates/${this.zoneSelected.id}/zoned-areas`)
				.then(res => {
					this.resetMap();
					this.initZones(res.data.zonedArea.zones);
					if (this.zones.length > 0) {
						this.map.setCenter(
							this.getCentroid(this.zones[0].polygon)
						);
					}
					this.loading = false;
				})
				.catch(this.$root.handleRequestError);
		},
		resetMap() {
			this.zones.forEach(zone => {
				if (zone.polygon) zone.polygon.setMap(null);
				if (zone.infoWindow) zone.infoWindow.close();
			});
		},
		initZones(zones) {
			this.zones = zones.map(zone => {
				let polygon = this.createPolygon(zone.zoneGeoPoints);
				let infoWindow = this.createInfoWindow(zone, polygon);
				let auxZone = {
					active: false,
					id: zone.id,
					name: zone.name,
					polygon,
					infoWindow
				};
				return auxZone;
			});
			if (this.zones.length > 0) this.selectZone(this.zones[0]);
		},

		createPolygon(geoPoints) {
			let polygone = new window.google.maps.Polygon({
				paths: geoPoints.map(gp => ({
					lat: parseFloat(gp.latitude),
					lng: parseFloat(gp.longitude)
				})),
				...this.polygonNotEditableOpts
			});
			polygone.setMap(this.map);
			return polygone;
		},
		closeInfoWindows() {
			this.infoWindow.map(info => info.setMap(null));
		},
		createInfoWindow(zone, polygon) {
			const marker = new window.google.maps.Marker({
				position: this.getCentroid(polygon),
				map: this.map,
				title: zone.name
			});
			const infowindow = new window.google.maps.InfoWindow({
				data: zone,
				marker: marker,
				content: zone.name
			});
			this.infoWindow.push(infowindow);
			return marker.addListener("click", () => {
				this.selectZone(zone);
				this.closeInfoWindows();
				infowindow.open({
					anchor: marker,
					map: this.map,
					shouldFocus: false
				});
			});
		},
		getCentroid(polygon) {
			let PI = 22 / 7;
			let X = 0;
			let Y = 0;
			let Z = 0;
			polygon.getPath().forEach(function(vertex) {
				let lat1 = vertex.lat();
				let lon1 = vertex.lng();
				lat1 = (lat1 * PI) / 180;
				lon1 = (lon1 * PI) / 180;
				X += Math.cos(lat1) * Math.cos(lon1);
				Y += Math.cos(lat1) * Math.sin(lon1);
				Z += Math.sin(lat1);
			});
			let Lon = Math.atan2(Y, X);
			let Hyp = Math.sqrt(X * X + Y * Y);
			let Lat = Math.atan2(Z, Hyp);
			Lat = (Lat * 180) / PI;
			Lon = (Lon * 180) / PI;
			return new window.google.maps.LatLng(Lat, Lon);
		}
	}
};
</script>
<style>
#zones-map {
	width: 100%;
	height: 500px;
}
</style>
